export enum UserPlatformEnum {
  Email = "email",
  Twitter = "twitter",
  Telegram = "telegram",
  Facebook = "facebook",
  Discord = "discord",
  Web = "web",
  Medium = "medium",
  Github = "github",
  Youtube = "youtube",
}

export interface UserPlatformIF {
  platform: UserPlatformEnum;
  display: string;
  data: string;
  is_visible?: boolean;
}
